<template>
  <div>
    <div class="tab-wrapper">
      <GroupOrderTierHeader
        :title="`General`"
        :disabled="true"
        customStyles="border-radius: 12px; padding-left: 3rem"
        :isGroupOrderTier="false"
      />
      <div class="general-section">
        <div class="head-content">
          <p>Due Date</p>
          <span>{{
            projectDetails.inHandsDate
              ? defaultFormatAndParse(projectDetails.inHandsDate)
              : 'N/A'
          }}</span>

          <p>Status</p>
          <span>{{
            projectDetails.enableCollectionLink ? 'Unlocked' : 'Locked'
          }}</span>

          <p>CSM</p>
          <span>{{ projectDetails.customerSuccessManager || 'N/A' }}</span>

          <p>Submissions</p>
          <span>{{ projectDetails.numberOfSubmissions }}</span>

          <p class="pill-holder">Lock project</p>
          <div>
            <div class="toggle-info text-left">
              <label
                class="toggle-button"
                :class="{ disabled: projectDetails.enableCollectionLink }"
              >
                <input
                  type="checkbox"
                  :checked="!projectDetails.enableCollectionLink"
                  @click.prevent="enableDisableCollectionLink"
                />
                <span class="toggle-slider round"></span>
              </label>
              <small class="lock-status">{{
                !projectDetails.enableCollectionLink
                  ? 'Not accepting submissions'
                  : 'Accepting submissions'
              }}</small>
            </div>
          </div>

          <div class="flex items-center gap-1">
            <p class="pill-holder">Email verification</p>
            <div class="tool-tip">
              <ToolTipInfo
                popOverContent="Add email verification during sign-in to check whether emails have permission to access the project."
                popOverPosition="left"
                popoverWrapperClass="relative md:-left-28 md:top-8"
                icon="i"
              />
            </div>
          </div>
          <div>
            <div class="toggle-info text-left">
              <label
                class="toggle-button"
                :class="{ disabled: projectDetails.verifyEmails }"
              >
                <input
                  type="checkbox"
                  :checked="projectDetails.verifyEmails"
                  @click.prevent="onEnableEmailVerification"
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="head-content-mobile">
        <div class="head-content-mobile-container">
          <p>Due Date</p>
          <span>{{
            projectDetails.inHandsDate
              ? defaultFormatAndParse(projectDetails.inHandsDate)
              : 'N/A'
          }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p>Status</p>
          <span>{{
            projectDetails.enableCollectionLink ? 'Unlocked' : 'Locked'
          }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p>Submissions</p>
          <span>{{ projectDetails.numberOfSubmissions }}</span>
        </div>
        <div class="head-content-mobile-container">
          <p class="pill-holder">Lock</p>
          <div>
            <div class="toggle-info text-left">
              <label
                class="toggle-button"
                :class="{ disabled: projectDetails.enableCollectionLink }"
              >
                <input
                  type="checkbox"
                  :checked="!projectDetails.enableCollectionLink"
                  @click.prevent="enableDisableCollectionLink"
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="head-content-mobile-container">
          <p>CSM</p>
          <span>{{ projectDetails.customerSuccessManager || 'N/A' }}</span>
        </div>
        <div class="head-content-mobile-container">
          <div class="flex items-center gap-1">
            <p class="pill-holder">Email verification</p>
            <div class="tool-tip">
              <ToolTipInfo
                popOverContent="Add email verification during sign-in to check whether emails have permission to access the project."
                popOverPosition="right"
                icon="i"
              />
            </div>
          </div>
          <div>
            <div class="toggle-info text-left">
              <label
                class="toggle-button"
                :class="{ disabled: projectDetails.verifyEmails }"
              >
                <input
                  type="checkbox"
                  :checked="projectDetails.verifyEmails"
                  @click.prevent="onEnableEmailVerification"
                />
                <span class="toggle-slider round"></span>
              </label>
              <small class="lock-status">{{
                projectDetails.enableCollectionLink
                  ? 'Not accepting submissions'
                  : 'Accepting submissions'
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Title Region Here -->
      <!-- <div class="background-content-holder">
        <div class="region-holder">
          <div class="customizables">
            <p>Attachments</p>

            <div class="caption">
              <div
                class="flex flex-col md:flex-row gap-3 md:gap-3 items-start md:items-center"
              >
                <label
                  for="file-upload"
                  class="underline relative cursor-pointer flex items-center gap-1"
                >
                  Upload file
                  <span> <img src="../../assets/upload.svg" alt="" /> </span>
                </label>
                <span class="input-info"
                  >File formats accepted: jpg, png, pdf, csv, xls or,
                  xlsx.</span
                >
                <input
                  type="file"
                  name=""
                  id="file-upload"
                  class="fil-input"
                  @change="uploadAttatchment"
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="custom-section-holder">
        <GroupOrderTierHeader
          :title="`Custom`"
          :disabled="true"
          customStyles="border-radius: 12px; padding-left: 3rem"
          :isGroupOrderTier="false"
        />
      </div>

      <!-- Customizables Here -->
      <section v-if="projectDetails.state !== 'finalized'">
        <div class="background-content-holder margin-top-2">
          <div class="info-holder-sub-header">Cover Page</div>

          <!-- Title Region Here -->
          <div class="region-holder">
            <div class="title">
              <p class="text-left"><strong>Heading </strong></p>
              <small>Select a heading for your project page landing.</small>
            </div>

            <!-- Default Title Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  name="project-title"
                  label="Default"
                  value="default-title"
                  v-model="orderTitle"
                  :isGroupOrder="false"
                  :isTransparent="true"
                  @change="onTitleChange($event, 'defaultTitle')"
                  custom-styles="font-size: 0.813rem; font-weight: 600"
                />
              </div>

              <div class="caption">
                <p>Welcome to {{ projectDetails.name }} for {{ team.name }}!</p>
              </div>
            </div>

            <!-- Custom Title Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  name="project-title"
                  label="Custom"
                  value="custom-title"
                  v-model="orderTitle"
                  :isTransparent="true"
                  :isGroupOrder="true"
                  @change="onTitleChange($event, 'customTitle')"
                  custom-styles="font-size: 0.813rem; font-weight: 600"
                />
              </div>

              <!-- <div class="caption"> -->
              <div class="flex flex-col md:flex-col gap-3 w-full">
                <textarea
                  id="title-textarea"
                  :disabled="orderTitle !== 'custom-title'"
                  rows="1"
                  placeholder="Add title*"
                  v-model="customTitle"
                  @keyup="handleKeyUp"
                  @blur="handleBlur('title')"
                ></textarea>
                <small class="characters-info"> </small>
                <small class="characters-info">
                  {{
                    `${customTitleCharactersLeft} ${
                      customTitleCharactersLeft > 1 ? 'words' : 'word'
                    }  left`
                  }}
                </small>
              </div>
              <!-- </div> -->
            </div>
          </div>

          <!-- Description Region Here -->
          <div class="region-holder custom-margin">
            <div class="customizables">
              <p>Description</p>
            </div>

            <!-- Default Description Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Default"
                  value="default-description"
                  :isGroupOrder="true"
                  v-model="projectDescription"
                  @change="onDescriptionChange($event, 'defaultDescription')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <div class="caption">
                <p>
                  You've been invited by {{ projectDetails.name }} to submit
                  your information to receive swag or a special gift.
                </p>
              </div>
            </div>

            <!-- Custom Description Here -->
            <div class="customizables">
              <div class="radio-holder">
                <radio-button
                  label="Custom"
                  value="custom-description"
                  v-model="projectDescription"
                  :isGroupOrder="true"
                  @change="onDescriptionChange($event, 'customDescription')"
                  custom-styles="font-size: 0.813rem"
                />
              </div>

              <div class="flex flex-col md:flex-col gap-3 w-full">
                <textarea
                  :class="{
                    custom: projectDescription == 'custom-description'
                  }"
                  :disabled="projectDescription !== 'custom-description'"
                  :rows="projectDescription == 'custom-description' ? 3 : 1"
                  placeholder="Add description*"
                  v-model="customDescription"
                  @keyup="handleKeyUp"
                  @blur="handleBlur('description')"
                ></textarea>
                <small class="characters-info"> </small>
                <small class="characters-info">
                  {{
                    `${customDescriptionCharactersLeft} ${
                      customDescriptionCharactersLeft > 1 ? 'words' : 'word'
                    }  left`
                  }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- </div> -->
      </section>
      <!-- Sub Title Region Here -->
      <!-- <div class="region-holder special-instruction">
            <div class="customizables">
              <div class="input-label flex items-start">
                <p>Special instructions (optional)</p>

                <div class="tool-tip">
                  <ToolTipInfo
                    popOverContent="This will be on the product page."
                    popOverPosition="right"
                  />
                </div>
              </div>

              <textarea
                id="title-textarea"
                rows="1"
                placeholder="Add title*"
                v-model="customSubTitle"
                @paste="handleKeyUp"
                @keyup="handleKeyUp"
              ></textarea>
              <small class="characters-info"> </small>
              <small class="characters-info">
                {{
                  `${customSubTitleCharactersLeft} ${
                    customSubTitleCharactersLeft > 1 ? 'words' : 'word'
                  }  left`
                }}
              </small>
            </div>
          </div> -->

      <div class="custom-section-holder">
        &nbsp;
      </div>
      <div class="background-content-holder margin-bottom-1">
        <section>
          <!-- Special Instructions Region Here -->
          <div class="info-holder-sub-header">Product Selection(s)</div>
          <div class="region-holder">
            <div class="title">
              <p class="text-left">
                <strong>Additional instructions </strong>
              </p>
              <small
                >Add any additional instructions or recommendations to users for
                selecting products or completing the form. This text will be
                displayed under the form title/heading.</small
              >
            </div>
          </div>
          <div class="detail">
            <div class="customize-section">
              <div class="input-holder special-instruction-holder">
                <textarea
                  id="title-textarea"
                  rows="1"
                  placeholder="Type instructions"
                  v-model="customSubTitle"
                  @paste="handleKeyUp"
                  @keyup="handleKeyUp"
                ></textarea>
                <small class="characters-info"> </small>
                <small class="characters-info">
                  {{
                    `${customSubTitleCharactersLeft} ${
                      customSubTitleCharactersLeft > 1 ? 'words' : 'word'
                    }  left`
                  }}
                </small>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="custom-section-holder">
        <GroupOrderTierHeader
          :title="`Page Access`"
          :disabled="true"
          customStyles="border-radius: 12px; padding-left: 3rem"
          :isGroupOrderTier="false"
        />
      </div>

      <div class="background-content-holder margin-top-1 page-access-margin">
        <section>
          <!-- Title Region Here -->
          <div class="region-holder mb-0">
            <div class="title">
              <p class="text-left  margin-top-1">
                <strong>Sign-in method </strong>
              </p>
              <small>Select how users can sign in to your projects page.</small>
            </div>
          </div>

          <!-- Allowed List Here -->
          <div class="background-content login-methods">
            <GroupOrderLoginMethods
              :isProjects="true"
              @onUpdateDomains="handleUpdateDomains"
              :allowed_domains="projectDetails.allowedDomains"
            />
          </div>
        </section>
      </div>
    </div>
    <section
      class="flex md:w-1/3 gap-4 justify-center md:justify-end projects-footer-actions"
    >
      <button class="button-gemnote button-gemnote--small custom-button w-full">
        <span>Cancel</span>
      </button>
      <button
        class="button-gemnote button-gemnote--small  w-full"
        @click="handleSaveChanges"
      >
        <span>Save Changes</span>
      </button>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DateFns from '@/mixins/DateFns'
import { progressStatus } from '../../helpers'
import RadioButton from '../Universal/RadioButton.vue'
import ToolTipInfo from '../Universal/ToolTipInfo.vue'
import GroupOrderTierHeader from '../GroupOrder/GroupOrderTierHeader.vue'
import GroupOrderLoginMethods from '@/components/GroupOrder/LoginMethods'
import { debounce } from 'lodash'
let bodyFormData = new FormData()

export default {
  name: 'ProjectSettingsTab',
  mixins: [DateFns],
  props: ['id'],
  components: {
    // CopyBanner,
    // InputTag,
    RadioButton,
    ToolTipInfo,
    GroupOrderTierHeader,
    GroupOrderLoginMethods
  },
  created() {
    // console.log(this.projectDetails)
  },
  mounted() {
    this.updateData()
  },
  data: () => ({
    whitelistedDomains: [],
    tabs: [
      { name: 'Settings', isActive: true },
      { name: 'Submissions', isActive: false }
    ],
    orderTitle: 'default-title',
    customTitle: '',
    projectDescription: 'default-description',
    customDescription: '',
    attatchments: [],
    customSubTitle: '',
    customTitleMaxCharacters: 10,
    customDescriptionMaxCharacters: 100,
    customSubTitleMaxCharacters: 10,
    allowed_domains: []
  }),
  computed: {
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),

    loadStatus() {
      return progressStatus(this.loadingProjectDetails)
    },

    isModalActive() {
      return this.activeModals('finalizeOrder')
    },

    ...mapState({
      toggleAddressCollection: state => state.project.toggleAddressCollection,
      loadingProjectDetails: state => state.project.loadingProjectDetails,
      projectDetails: state => state.project.projectDetails,
      updatingAllowedDomains: state => state.project.updatingAllowedDomains,
      finalizingOrder: state => state.project.finalizingOrder,
      team: state => state.team.team
    }),
    customTitleCharactersLeft() {
      if (this.customTitle) {
        return (
          this.customTitleMaxCharacters - this.customTitle.split(' ').length
        )
      } else {
        return this.customTitleMaxCharacters
      }
    },
    customDescriptionCharactersLeft() {
      if (this.customDescription) {
        return (
          this.customDescriptionMaxCharacters -
          this.customDescription.split(' ').length
        )
      } else {
        return this.customDescriptionMaxCharacters
      }
    },
    customSubTitleCharactersLeft() {
      if (this.customSubTitle) {
        return (
          this.customSubTitleMaxCharacters -
          this.customSubTitle.split(' ').length
        )
      } else {
        return this.customSubTitleMaxCharacters
      }
    }
  },

  methods: {
    handleUpdateDomains(domains) {
      this.allowed_domains = domains
      this.updateGroupOrder()
    },

    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    },

    updateData() {
      if (this.projectDetails.enableCustomTitle) {
        this.orderTitle = 'custom-title'
      }
      if (this.projectDetails.enableCustomDescription) {
        this.projectDescription = 'custom-description'
      }
      this.customTitle = this.projectDetails.adminOrderTitle
      this.customSubTitle = this.projectDetails.adminOrderSubheading
      this.customDescription = this.projectDetails.adminOrderDescription
      this.allowed_domains = this.projectDetails.allowedDomains
    },

    onEnableEmailVerification() {
      if (this.projectDetails.verifyEmails) {
        this.$store.dispatch(
          'project/disableEmailVerification',
          this.projectDetails.uuid
        )
      } else {
        this.$store.dispatch(
          'project/enableEmailVerification',
          this.projectDetails.uuid
        )
      }
    },

    enableDisableCollectionLink() {
      if (!this.projectDetails.enableCollectionLink) {
        this.$store.dispatch(
          'project/enableAddressCollectionLink',
          this.$route.params.id
        )
      } else {
        this.$store.dispatch(
          'project/disableAddressCollectionLink',
          this.$route.params.id
        )
      }
    },
    doCopy() {
      if (this.projectDetails.recipientCollectionAdminOrderUrl) {
        this.$copyText(this.projectDetails.recipientCollectionAdminOrderUrl)
        this.$store.dispatch('notification/pushNotification', {
          type: 'success',
          messages: [`Link copied`]
        })
      }
    },
    handleSaveChanges() {
      this.$store.dispatch('notification/pushNotification', {
        type: 'success',
        messages: [`Project settings saved successfully.`]
      })
    },

    updateWhitelistedDomain(domains) {
      this.$store.dispatch('project/updateWhitelistedDomain', domains)
    },

    validateEmail(value) {
      // eslint-disable-next-line no-useless-escape
      return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
        value
      )
    },

    finalizeOrder() {
      this.$store.dispatch('project/finalizeOrder')
    },

    handleModal() {
      this.$store.dispatch('modal/showRemoveModal', 'finalizeOrder')
    },

    onTitleChange(e, value) {
      if (value == 'defaultTitle') {
        this.redemptionTitle = 'default-title'
        this.updateGroupOrder(e, value)
      } else if (value == 'customTitle') {
        this.redemptionTitle = 'custom-title'
        this.updateGroupOrder(e, value)
      }
    },
    onDescriptionChange(e, value) {
      if (value == 'defaultDescription') {
        this.redemptionDescription = 'default-description'
        this.updateGroupOrder(e, value)
      } else if (value == 'customDescription') {
        this.redemptionDescription = 'custom-description'
        this.updateGroupOrder(e, value)
      }
    },
    onSubtitleChange(e, value) {
      this.updateGroupOrder(e, value)
    },
    uploadAttatchment(e) {
      if (e.target.files) {
        let file = null

        if (e.target.files.length > 1) {
          file = e
        } else {
          file = e.target.files[0]
        }

        const myNewFile = new File(
          [file],
          file.name.replace(/[^a-zA-Z0-9 ]/g, ''),
          {
            type: file.type
          }
        )
        if (file) {
          bodyFormData.delete('admin_order_attatchments')
          bodyFormData.append('admin_order_attatchments', myNewFile)
          bodyFormData.append('admin_order_attatchments', this.attatchments)
          bodyFormData.append('admin_order_title', this.customTitle)
          bodyFormData.append('admin_order_description', this.customDescription)
          bodyFormData.append('allowed_domains', this.allowed_domains)
          bodyFormData.append(
            'enable_custom_title',
            this.redemptionTitle === 'default-title' ? false : true
          )
          bodyFormData.append(
            'enable_custom_description',
            this.redemptionDescription === 'default-description' ? false : true
          )
        }

        this.$store.dispatch(
          'project/updateAdminorderAttatchments',
          bodyFormData
        )

        bodyFormData = new FormData()
      }
    },
    handleBlur(type) {
      // resets back to default if user leave custom title/description/password field empty
      switch (type) {
        case 'title':
          if (this.customTitle === '') {
            this.redemptionTitle = 'default-title'
            this.updateGroupOrder({}, 'defaultTitle')
          }
          break
        case 'description':
          if (this.customDescription === '') {
            this.redemptionDescription = 'default-description'
            this.updateGroupOrder({}, 'defaultDescription')
          }
          break
        case 'password':
          if (this.password === '') {
            this.passwordValue = 'password'
          }
      }
    },

    updateGroupOrder() {
      this.$store
        .dispatch('project/updateProjectOrder', {
          admin_order_title: this.customTitle,
          admin_order_description: this.customDescription,
          allowed_domains: this.allowed_domains,
          enable_custom_subheading: Boolean(this.customSubTitle),
          admin_order_subheading: this.customSubTitle,
          enable_custom_title:
            this.redemptionTitle === 'default-title' ? false : true,
          // setting values for whether redemption description should be true or false
          enable_custom_description:
            this.redemptionDescription === 'default-description' ? false : true,
          admin_order_attatchments: this.attatchments
        })
        .then(() => {
          console.log('updated')
        })
    },

    handleCustomChange(e, type) {
      if (this[type].length > 0) {
        this.updateGroupOrder(e)
      }
    },
    handleKeyUp: debounce(function(e) {
      console.log(e)
      this.updateGroupOrder(e)
    }, 1500)
  },
  watch: {
    customTitle(newVal) {
      if (this.customTitleCharactersLeft > 0) {
        this.customTitle = newVal
      } else {
        this.customTitle = newVal
          .split(' ')
          .splice(0, this.customTitleMaxCharacters)
          .join(' ')
      }
    },
    customDescription(newVal) {
      if (this.customDescriptionCharactersLeft > 0) {
        this.customDescription = newVal
      } else {
        this.customDescription = newVal
          .split(' ')
          .splice(0, this.customDescriptionMaxCharacters)
          .join(' ')
      }
    },
    customSubTitle(newVal) {
      if (this.customSubTitleCharactersLeft > 0) {
        this.customSubTitle = newVal
      } else {
        this.customSubTitle = newVal
          .split(' ')
          .splice(0, this.customSubTitleMaxCharacters)
          .join(' ')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/global.scss';
.head-content-mobile {
  display: none;
}

.tab-wrapper {
  border-radius: 29px;
  padding: 0.2rem 0.8rem !important;
  background: inherit;
  border: 1px solid #000;
  overflow: hidden;

  .general-section {
    padding: 2rem 3rem 0px 3rem;

    small.lock-status {
      font-size: 0.613rem;
      color: #514d43;
      position: relative;
      left: 8px;
    }
  }

  .head-content {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 150px 1fr;
    margin-bottom: 2rem;
    align-items: center;

    p {
      text-align: left;
      font-weight: bold;
      font-size: 0.813rem;
      color: $main-6;
    }

    span {
      text-align: left;
      font-size: 0.813rem;
      color: $main-6;
    }
  }
  .background-content-holder {
    padding: 0 3.2rem;
    .info-holder-sub-header {
      font-size: 0.838rem;
      margin-bottom: 1.2rem;
      color: #a09c95;
      font-weight: 600;
      text-align: left;
    }
  }

  .domain-content {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 170px 50%;
    margin-bottom: 4rem;

    p {
      text-align: left;
      font-weight: bold;
      align-self: start;
      font-size: $content-font-size;
    }
  }

  .body-content {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 170px 1fr;
    margin-bottom: 4rem;

    p {
      text-align: left;
      font-weight: bold;
      align-self: start;
      font-size: $content-font-size;
    }
  }

  .page-link-content {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 170px 1fr;

    p {
      text-align: left;
      font-weight: 600;
      align-self: center;
      font-size: $content-font-size;
    }

    .link-content {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;

      .copy-holder {
        border-left: 1px solid $onyx;

        p {
          font-weight: 400;
        }
      }

      span {
        min-width: 50px;
        text-align: justify;
        padding: 1rem;
        word-break: break-all;
        font-size: $content-font-size;
        width: 100%;
        color: $main-6;
      }

      small {
        padding-top: 8px;
        font-size: 0.563rem;
        text-align: left;
        color: rgba(36, 41, 44, 0.5);
      }

      div {
        min-width: 50px;

        &.primary {
          border: 1px solid $onyx;
        }

        img {
          cursor: pointer;
          width: 1.2rem;
        }
      }
    }
  }
}

.custom-section-holder {
  border-top: 1px solid #dfdad2;
  padding-top: 0.3rem;
}
.allow-domains {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1rem;

  .label {
    flex-basis: 170px;
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 14px;
    font-weight: bold;

    .text {
      font-size: 0.813rem;
      margin: 0;
    }
  }

  .project {
    .vue-input-tag-wrapper {
      min-width: 73%;
      max-width: 100%;

      .remove {
        font-size: 0.613rem;
      }
    }
  }

  div {
    display: flex;
  }

  h5 {
    padding-right: 10px;
  }
}

.domain-tag-input {
  flex-basis: 70%;
  flex-shrink: 0;
}

.region-holder {
  margin-bottom: 2rem;
  &.mb-0 {
    margin-bottom: 0;
  }
  .title {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-bottom: 1.2rem;
    p {
      font-size: 0.838rem;
    }
    small {
      text-align: left;
      color: #514d43;
      font-size: 0.758rem;
    }
  }
}

.special-instruction {
  .input-label {
    display: flex;
    gap: 10px;
  }

  padding-top: 20px;
  // padding-bottom: 20px;
}

.customizables {
  display: grid;
  grid-template-columns: 170px 1fr;
  margin-bottom: 1.125rem;
  gap: 1rem;

  /* .radio-holder { */
  /* width: 20%; */
  /* display: flex;
    align-items: center; */
  /* } */

  textarea {
    background: inherit;
    font-family: $nunito;
    padding: 2px 0;
    width: 65%;
    max-width: 70%;
    resize: none;
    border: none;
    border-bottom: 1px solid #24292c;
    font-size: 0.875rem;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }
  }
  .characters-info {
    position: relative;
    top: -12px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 65%;
    max-width: 70%;
    text-align: right;
  }

  .characters-info {
    position: relative;
    top: -12px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 65%;
    max-width: 70%;
    text-align: right;
  }

  .password-holder {
    width: 40%;
    position: relative;

    input {
      height: 1.75rem;
      padding: 2px 0;
      font-size: 0.875rem;
      background: inherit;
      font-family: $nunito;
      border: none;
      border-bottom: 1px solid #24292c;
    }

    span {
      position: absolute;
      top: 9px;
      right: 0;
      font-size: 0.625rem;
      color: #676767;
      cursor: pointer;
    }
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }

  p {
    text-align: left;
    font-weight: bold;
    align-self: center;
    font-size: $content-font-size;
  }

  div.caption {
    width: 95%;

    p {
      font-weight: 400;
      line-height: 23px;

      &:nth-child(2) {
        margin-top: 1.25rem;
      }

      &:nth-child(3) {
        margin: 0.5rem 0;
      }
    }
  }
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: red;
  display: block;
  opacity: 0;
  cursor: pointer;
  display: block !important;
}

.caption {
  .input-info {
    font-size: 0.761rem;
    text-align: left;
    color: #23222080;
  }
}

.special-instruction-holder {
  width: 60%;
  padding-top: 0px;
  textarea {
    margin-bottom: 0.5rem;
    background: inherit;
    font-family: $nunito;
    padding: 10px;
    width: 100%;
    display: block;
    /* margin-left: 0; */
    resize: none;
    border: none;
    border: 1px solid #9b9b9b;
    font-size: 0.875rem;
    min-height: 160px;

    @media (max-width: 576px) {
      width: 100%;
    }

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }

    &.error {
      border-bottom: 1px solid #da5737;
    }
    &::placeholder {
      font-size: 0.815rem;
      color: #a09c95;
    }
  }
  .characters-info {
    position: relative;
    top: -10px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 100%;
    max-width: 100%;
    text-align: right;
    display: block;
    padding-top: 0.2rem;
  }
}

.projects-footer-actions {
  margin: 1.5rem auto;
  .button-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    font-weight: 500;
    width: auto;
    border-color: #232220;

    &.custom-button {
      background: inherit;
      color: #232220;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
  .whitebutton-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    width: auto;
    border-color: #232220;
    background-color: #232220;
    color: #fff;

    &.custom-button {
      background: inherit;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
}

@media (max-width: 860px) {
  .background-content-holder {
    padding: 1.2rem 0 !important;
    &.margin-top-2,
    &.margin-top-1 {
      margin-top: 0;
    }
  }
  .head-content {
    display: none !important;
    flex-wrap: wrap;
  }
  .general-section {
    display: none;
  }
  .head-content-mobile {
    display: grid;
    justify-content: left;
    margin-top: 1rem;
    p {
      text-align: left;
      font-weight: bold;
      font-size: 0.813rem;
      color: $main-6;
    }

    span {
      text-align: left;
      font-size: 0.813rem;
      color: $main-6;
    }
  }
  .head-content-mobile-container {
    display: grid;
    margin-bottom: 20px;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    .toggle-info {
      width: max-content;
    }
    div {
      .toggle-info {
        width: max-content;
      }
    }
    small.lock-status {
      font-size: 0.613rem;
      color: #514d43;
      position: relative;
      left: 8px;
      display: block;
    }
  }
  .tab-wrapper .page-link-content {
    display: block;
    p {
      margin-bottom: 12px;
    }
  }
  .copy-holder {
    p {
      padding-top: 12px;
      width: 250px !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .allow-domains {
    display: block;
  }
  .allow-domains .project .vue-input-tag-wrapper {
    width: 100%;
  }
  .customizables {
    display: flex;
  }
  .customizables textarea {
    height: 100px;
  }
}
.page-access-margin {
  margin-bottom: 2rem;
}
.custom-margin {
  margin-bottom: 0.8rem !important;
}
</style>
